const state = {
    savedShiurim: [],
    inProgressShiurim: [],
    followedSpeakers: [],
    shiurimNewsletter: {},
};

const mutations = {
    save_saved_shiurim: function (state, shiurim) {
        state.savedShiurim = shiurim;
    },
    save_in_progress_shiurim: function (state, shiurim) {
        state.inProgressShiurim = shiurim;
    },
    save_following_speakers: function (state, followedSpeakers) {
        state.followedSpeakers = followedSpeakers;
    },
    save_shiurim_newsletter: function (state, newsletter) {
        state.shiurimNewsletter = newsletter;
    },
};

const actions = {
    loadSavedShiurim: function (context, savedShiurim) {
        return context.commit("save_saved_shiurim", savedShiurim);
    },
    loadInProgressShiurim: function (context, inProgressShiurim) {
        return context.commit("save_in_progress_shiurim", inProgressShiurim);
    },
    loadFollowingSpeakers: function (context, followedSpeakers) {
        return context.commit("save_following_speakers", followedSpeakers);
    },
    loadShiurimNewsletter: function (context, newsletter) {
        return context.commit("save_shiurim_newsletter", newsletter);
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
